import styled from 'styled-components';
import DefaultTypography from '@bexs/dollar/components/Typography';

export const DescriptionSubtitle = styled(DefaultTypography)`
  color: #6f6f6f;
`;
